module.exports = __webpack_public_path__ + "media/images/icons/round-checkmark-e26c2711f004cdee163f1f4135078554.svg";